module.exports = __webpack_public_path__ + "static/02-8490dfbcc0f5c066d1aa307ec3ad19bd.png";